import React, { Component } from "react";
import { observer } from "mobx-react";
import {
    fn_timeSalesExcelList,
    fn_salesTimeSearch,
    fn_getDateTerm,
    fn_getSearchView,
    fn_setDateTerm,
    fn_setSearchVal,
    fn_setSearchView,
    fn_setBeforeDetailUpdate,
    fn_initSalesProductAll,
    fn_getHelpSearchView,
    fn_setHelpSearchView
} from "../../../../function/FnBodySales";
import EndDatePicker from "./EndDatePicker";
import StartDatePicker from "./StartDatePicker";
import { Link } from "react-router-dom";
import SalesDefaultLeftView from "./SalesDefaultLeftView";
import { replaceStringNum, analyticeEvent, graphHeight, formatPriceUnit, getMaxValueY } from "utils/Utils"
import { fn_bridge_print } from "function/FnPosBridge"
import { fn_auth_pop } from "function/FnBodyLayer";
import SettingStore from "stores/SettingStore";

@observer
class SalesTime extends Component {

    inputBoxDel = (e) => {
        const { rootStore } = this.props;
        fn_setSearchVal(rootStore, "")
        document.getElementById("productName").value = "";
        fn_salesTimeSearch(rootStore);
    }

    componentDidMount() {
        const { rootStore } = this.props;
        fn_initSalesProductAll(rootStore);
        fn_setDateTerm(rootStore, 'today', true);
        fn_salesTimeSearch(rootStore);
    }

    barClick = (index, item, type) => {
        const { rootStore } = this.props;
        let barInner = document.getElementsByClassName('bar_inner')

        if (barInner[index].classList.contains('on') == true) {
            barInner[index].classList.remove('on')
            barInner[index].classList.remove('click')
        } else {
            for (let i = 0; i < barInner.length; i++) {
                barInner[i].classList.remove('on')
                barInner[i].classList.remove('click')
            }

            if (item.sales != 0) {
                document.getElementById('time' + index).classList.add('on')
                document.getElementById('time' + index).classList.add('click')

            }
        }
    };

    render() {
        const { rootStore } = this.props;
        let salesStore = rootStore.salesStore;
        let yAxisMax = 0;

        if (salesStore.getTotalSalesTimeVal.totalSales != 0) {
            const trueMaxSales = replaceStringNum(salesStore.getSalesTimeRank[0].sales);
            yAxisMax = getMaxValueY(trueMaxSales);
        }

        return (
            <>
                <div className="article_setting">
                    <div className={(fn_getHelpSearchView(rootStore)) ? "bg" : "hide"}
                        onClick={event => {
                            fn_setHelpSearchView(rootStore, !fn_getHelpSearchView(rootStore));
                        }}>
                    </div>
                    {/*왼쪽 메뉴 */}
                    <SalesDefaultLeftView rootStore={rootStore} />
                    <div className="section_content sales time">
                        <div className="top">
                            <h3>시간대 분석</h3>
                            <span className={(rootStore.layerStore.getLayerHelpView) ? "ico on" : "ico"} onClick={event => {
                                rootStore.layerStore.setLayerHelpView(true);
                                analyticeEvent("help", "helpTimeSales Button", rootStore.searchStore.getShopCd)
                            }}></span>
                            <div className={(rootStore.layerStore.getLayerHelpView) ? "" : "hide"}>
                                <div className="info group">
                                    <strong>매출 집계 기준이 무엇인가요?</strong><br />
                                    영업일, 주문시간 기준 매출이에요<br />
                                    할인금액은 매출로 자동 집계해요
                                </div>
                                <div className="info excel">
                                    <strong>엑셀 파일을 열어 보시려면</strong><br />
                                    엑셀(뷰어) 프로그램이 필요해요
                                </div>
                            </div>
                            <button className="btn excel" onClick={event => {
                                event.preventDefault();
                                fn_timeSalesExcelList(rootStore);
                                analyticeEvent("timeSales", "timeSalesExcel", rootStore.searchStore.getShopCd)
                            }}>엑셀 저장</button>
                            <button className="btn print" onClick={event => {
                                event.preventDefault();
                                fn_bridge_print(rootStore, "6");
                                analyticeEvent("timeSales", "timeSalesEasyPrint", rootStore.searchStore.getShopCd)
                            }}>간편 인쇄</button>
                        </div>
                        <div className="scroll">
                            <div className="inner">

                                < div className="article_order_history">
                                    <div className={(fn_getSearchView(rootStore).detail_area_view) ? "bg" : "hide"}
                                        onClick={event => {
                                            fn_setSearchView(rootStore, 'detail_area_view', !fn_getSearchView(rootStore).detail_area_view);
                                            fn_setBeforeDetailUpdate(rootStore);
                                        }}>
                                    </div>
                                    <div className={(fn_getSearchView(rootStore).key_area_view) ? "bg" : "hide"}
                                        onClick={event => fn_setSearchView(rootStore, 'key_area_view', !fn_getSearchView(rootStore).key_area_view)}>
                                    </div>
                                    <div className="section_order_history sales time">
                                        <div className="wrap_search" id='wrap_search'>
                                        {
                                                ( (rootStore.layerStore.getManagerAuthView.manager == "Y" || (rootStore.settingStore.getManagerSetting.salePage == "N" || rootStore.layerStore.getManagerAuthView.auth == "Y"))) ?
                                                    <>
                                            <div className="box_date">
                                                <div>
                                                    <div className="tit period">조회기간</div>
                                                </div>
                                                <label className="date" onClick={evnet => analyticeEvent("timeSalesSearch", "timeSalesSearchDatePickerStart Button", rootStore.searchStore.getShopCd)}>
                                                    <StartDatePicker rootStore={rootStore} />
                                                    <span className="ico_date"></span>
                                                </label>
                                                <div className="txt_bar">-</div>
                                                <label className="date" onClick={evnet => analyticeEvent("timeSalesSearch", "timeSalesSearchDatePickerEnd Button", rootStore.searchStore.getShopCd)}>
                                                    <EndDatePicker rootStore={rootStore} />
                                                    <span className="ico_date"></span>
                                                </label>
                                                <div className="selects term">
                                                    <label
                                                        onClick={event => {
                                                            event.preventDefault();
                                                            fn_setDateTerm(rootStore, 'today', true);
                                                            fn_salesTimeSearch(rootStore);
                                                            analyticeEvent("timeSalesSearch", "timeSalesSearchToday Button", rootStore.searchStore.getShopCd)
                                                        }}
                                                    >
                                                        <input type="radio" name="date" readOnly={true} checked={fn_getDateTerm(rootStore).today === true ? true : ""} />
                                                        <span className="txt today">오늘</span>
                                                    </label>
                                                    <label
                                                        onClick={event => {
                                                            event.preventDefault();
                                                            fn_setDateTerm(rootStore, 'yesterday', true);
                                                            fn_salesTimeSearch(rootStore);
                                                            analyticeEvent("timeSalesSearch", "timeSalesSearchYesterday Button", rootStore.searchStore.getShopCd)
                                                        }}
                                                    >
                                                        <input type="radio" name="date" readOnly={true} checked={fn_getDateTerm(rootStore).yesterday === true ? true : ""} />
                                                        <span className="txt befor">어제</span></label>
                                                    <label
                                                        onClick={event => {
                                                            event.preventDefault();
                                                            fn_setDateTerm(rootStore, 'lastmonth', true);
                                                            fn_salesTimeSearch(rootStore);
                                                            analyticeEvent("timeSalesSearch", "timeSalesSearchLastMonth Button", rootStore.searchStore.getShopCd)
                                                        }}
                                                    >
                                                        <input type="radio" name="date" readOnly={true} checked={fn_getDateTerm(rootStore).lastmonth === true ? true : ""} />
                                                        <span className="txt befor more">지난달</span></label>
                                                    <label
                                                        onClick={event => {
                                                            event.preventDefault();
                                                            fn_setDateTerm(rootStore, 'month', true);
                                                            fn_salesTimeSearch(rootStore);
                                                            analyticeEvent("timeSalesSearch", "timeSalesSearchThisMonth Button", rootStore.searchStore.getShopCd)
                                                        }}
                                                    >
                                                        <input type="radio" name="date" readOnly={true} checked={fn_getDateTerm(rootStore).month === true ? true : ""} />
                                                        <span className="txt week">이번달</span></label>
                                                </div>
                                                <div className="search_box">
                                                    <button type="submit" className="btn_search" onClick={event => {
                                                        fn_salesTimeSearch(rootStore);
                                                        analyticeEvent("timeSalesSearch", "timeSalesSearch", rootStore.searchStore.getShopCd)
                                                    }}>조회</button>
                                                </div>
                                            </div>
                                                    {
                                                        (salesStore.getTotalSalesTimeVal.totalSales != 0) ?
                                                        <>
                                                        <div className="box_pick">
                                                            <div className="tit">피크타임 매출</div>
                                                            <div className="pick all">
                                                                <p className="total">총매출</p>
                                                                <p className="sales"><span>{salesStore.getTotalSalesTimeVal.totalSales}</span> 원</p>
                                                                <p className="cnt"><span>{salesStore.getTotalSalesTimeVal.totalCount}</span> 건</p>
                                                            </div>
                                                            <div className="pick first">
                                                                <p className="time"><span></span>{salesStore.getSalesTimeRank[0].hourlyName}</p>
                                                                <p className="sales"><strong>{salesStore.getSalesTimeRank[0].sales}</strong> 원</p>
                                                                <p className="cnt"><strong>{salesStore.getSalesTimeRank[0].orderCount}</strong> 건</p>
                                                            </div>
                                                            <div className="pick second">
                                                                <p className="time"><span></span>{salesStore.getSalesTimeRank[1].hourlyName}</p>
                                                                <p className="sales"><strong>{salesStore.getSalesTimeRank[1].sales}</strong> 원</p>
                                                                <p className="cnt"><strong>{salesStore.getSalesTimeRank[1].orderCount}</strong> 건</p>
                                                            </div>
                                                            <div className="pick third">
                                                                <p className="time"><span></span>{salesStore.getSalesTimeRank[2].hourlyName}</p>
                                                                <p className="sales"><strong>{salesStore.getSalesTimeRank[2].sales}</strong> 원</p>
                                                                <p className="cnt"><strong>{salesStore.getSalesTimeRank[2].orderCount}</strong> 건</p>
                                                            </div>
                                                        </div>
                                                        <div className="box_graph">
                                                            <div className="tit">시간대별 매출
                                                                <span>그래프 클릭시 상세정보 조회</span>
                                                            </div>
                                                            <div id='wrap'>
                                                                <div className='wrap_graph'>
                                                                    <div className='inner'>
                                                                        <div className='divider'>
                                                                            <div className='b bh'></div>
                                                                            <div className='b bv'></div>
                                                                            <div className='h h1'></div>
                                                                            <div className='h h2'></div>
                                                                            <div className='h h3'></div>
                                                                            <div className='h h4'></div>
                                                                            <div className='h h5'></div>
                                                                            {/* <div className='v'></div> */}
                                                                        </div>
                                                                        <div className='price'>
                                                                            <div className='item item1'>{formatPriceUnit(yAxisMax)}</div>
                                                                            <div className='item item2'>{formatPriceUnit(yAxisMax * 0.8)}</div>
                                                                            <div className='item item3'>{formatPriceUnit(yAxisMax * 0.6)}</div>
                                                                            <div className='item item4'>{formatPriceUnit(yAxisMax * 0.4)}</div>
                                                                            <div className='item item5'>{formatPriceUnit(yAxisMax * 0.2)}</div>
                                                                        </div>
                                                                        <div className='graph_bar'>
                                                                            {salesStore.getSalesTimeList.map((item, index) => {
                                                                                return <div id={"time" + index} key={"time" + index}
                                                                                    className="bar_inner" onClick={event => { this.barClick(index, item); }}>
                                                                                    <div
                                                                                        className={item.sales == rootStore.salesStore.getSalesTimeRank[0].sales
                                                                                            || item.sales == rootStore.salesStore.getSalesTimeRank[1].sales
                                                                                            || item.sales == rootStore.salesStore.getSalesTimeRank[2].sales
                                                                                            ? 'bar point' : 'bar'
                                                                                        }
                                                                                        style={{
                                                                                            height: graphHeight(rootStore, yAxisMax, item.sales)
                                                                                        }}>
                                                                                        <div className='layer'>
                                                                                            <p className="info">
                                                                                                <span>{item.hourlyName}</span>
                                                                                                <span className="cnt">{item.orderCount}건</span>
                                                                                            </p>
                                                                                            <p className="info won">{item.sales} 원</p>
                                                                                        </div>
                                                                                    </div>
                                                                                </div>
                                                                            })}
                                                                        </div>
                                                                        <div className='time'>
                                                                            {
                                                                                salesStore.getSalesTimeList.map((item, index) => {
                                                                                    return <div key={index}>{index}</div>
                                                                                })
                                                                            }
                                                                            <div>24</div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className="box_detail">
                                                            <div className="tit">시간대별 매출 상세</div>
                                                            <div className="wrap_table time">
                                                                <table>
                                                                    <thead>
                                                                        <tr>
                                                                            <th>No.</th>
                                                                            <th>시간대</th>
                                                                            <th>주문건수</th>
                                                                            <th>매출</th>
                                                                            <th>매출 점유율</th>
                                                                        </tr>
                                                                    </thead>
                                                                    <tbody>
                                                                        {
                                                                            salesStore.getSalesTimeList.map((sales, idx) => (
                                                                                <tr id={"detail" + idx} key={"detail" + idx}>
                                                                                    <td className="row_no">{idx + 1}</td>
                                                                                    <td className="">{sales.hourlyName}</td>
                                                                                    <td className="pay sales">{sales.orderCount}건</td>
                                                                                    <td className="pay sales">{sales.sales}원</td>
                                                                                    <td className="pay sales">{sales.share}%</td>
                                                                                </tr>
                                                                            ))
                                                                        }
                                                                    </tbody>
                                                                    <tfoot>
                                                                        <tr>
                                                                            <td></td>
                                                                            <td>총합</td>
                                                                            <td className="num">{salesStore.getTotalSalesTimeVal.totalCount}건</td>
                                                                            <td className="num">{salesStore.getTotalSalesTimeVal.totalSales}원</td>
                                                                            <td className="num">100%</td>
                                                                        </tr>
                                                                    </tfoot>
                                                                </table>
                                                            </div>
                                                        </div>
                                                        </>
                                                        :
                                                        <div className="list_none time ">
                                                            <h5 className="tit"><span className="time">시간대별 매출이 없어요</span></h5>
                                                            <p className="print">조회기간을 확인해서 다시 조회해보세요</p>
                                                        </div>
                                                    }
                                                    </>
                                                    :
                                                    <div className="list_none time " id="list_none">
                                                        <h5 className="tit"><span className="time">관리자(점주) 인증이 필요해요</span></h5>
                                                        <p className="print">점주님 권한의 계정 인증 시에만 페이지를 조회할 수 있어요</p>
                                                        <div className="auth_btn_wrap">
                                                            <button className="auth btn" onClick={event => { event.preventDefault(); fn_auth_pop(rootStore) }}>
                                                            관리자 인증하기 <span></span></button>
                                                        </div>
                                                    </div>
                                            }
                                        </div>
                                    </div>
                                </div>


                            </div>
                        </div>
                        <div className="sales time close">
                            <Link to="/"><button type="button"><span className="btn_order_history_close">닫기</span></button></Link>
                        </div>


                    </div>
                </div >
            </>
        )
    }
}

export default SalesTime;